import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79d49fb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sdds-table sdds-table--compact sdds-table--no-min-width" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "sdds-table__header" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "sdds-table__row" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "sdds-table__header-cell" }),
    /*#__PURE__*/_createElementVNode("th", { class: "sdds-table__header-cell sdds-u-pl2 sdds-u-pr2" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "sdds-table__header-cell sdds-u-pl2 sdds-u-pr2" }, "File"),
    /*#__PURE__*/_createElementVNode("th", { class: "sdds-table__header-cell sdds-u-pl2 sdds-u-pr2" }, "Status")
  ])
], -1))
const _hoisted_3 = { class: "sdds-table__body" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["id"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  class: "sdds-svg-icon"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.013 4.004c-6.642 0-12.026 5.384-12.026 12.025 0 6.642 5.384 12.026 12.026 12.026 6.641 0 12.025-5.384 12.025-12.026 0-6.641-5.384-12.025-12.025-12.025ZM1.987 16.029c0-7.746 6.28-14.025 14.026-14.025 7.746 0 14.025 6.28 14.025 14.025 0 7.746-6.28 14.026-14.025 14.026-7.746 0-14.026-6.28-14.026-14.026Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.025 14.126a1 1 0 0 1 1 1v5.616a1 1 0 0 1-2 0v-5.616a1 1 0 0 1 1-1ZM16.025 10.317a1 1 0 0 1 1 1v.217a1 1 0 1 1-2 0v-.217a1 1 0 0 1 1-1Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "sdds-table__row",
  "data-test-id": "dataRowDetail"
}
const _hoisted_15 = {
  class: "sdds-table__body-cell",
  colspan: "4"
}
const _hoisted_16 = {
  key: 0,
  class: "sdds-table__footer"
}
const _hoisted_17 = { class: "sdds-table__footer-row" }
const _hoisted_18 = {
  class: "sdds-table__footer-cell",
  colspan: "5"
}
const _hoisted_19 = { class: "sdds-table__pagination" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sdds-table__row-selector" }, null, -1))
const _hoisted_21 = { class: "sdds-table__page-selector" }
const _hoisted_22 = ["max"]
const _hoisted_23 = { class: "sdds-table__footer-text" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" of ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" pages ")
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sdds-table__footer-btn-svg",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.217 4.273a1 1 0 0 1 0 1.415l-9.888 9.888a.6.6 0 0 0 0 .848l9.888 9.888a1 1 0 0 1-1.414 1.415l-9.889-9.889a2.6 2.6 0 0 1 0-3.677l9.889-9.888a1 1 0 0 1 1.414 0Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sdds-table__footer-btn-svg",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.783 27.727a1 1 0 0 1 0-1.415l9.888-9.888a.6.6 0 0 0 0-.848L9.783 5.688a1 1 0 0 1 1.414-1.415l9.889 9.889a2.6 2.6 0 0 1 0 3.676l-9.889 9.889a1 1 0 0 1-1.414 0Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_31 = [
  _hoisted_30
]

import { PropType, ref } from 'vue';
import che_down from '../assets/chevron_down.svg';
import che_up from '../assets/chevron_up.svg';
import { FileData } from '../types/types';
/* import search from '../assets/search.svg'; */

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FileHistoryTable',
  props: {
  fileData: {
    type: Array as PropType<Array<FileData>>,
    required: true,
  },
},
  emits: ['showDetailsRow'],
  setup(__props, { emit }) {

const props = __props



// eslint-disable-next-line

const details = ['typeImport', 'userId', 'createdOn'];

const fileRowsData = ref(props.fileData);
const tooltipKey = ref(0);

const showDetailsRow = (item) => {
  fileRowsData.value.forEach((row) => {
    row.showDetails = false;
  });
  item.showDetails = true;
  emit('showDetailsRow', { fileId: item.fileId.trim(), typeImport: item.typeImport });
};

const toISOStringWithTimezone = date => {
  const tzOffset = -date.getTimezoneOffset();
  const diff = tzOffset >= 0 ? '+' : '-';
  const pad = n => `${Math.floor(Math.abs(n))}`.padStart(2, '0');
  return date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate()) +
    ' ' + pad(date.getHours()) +
    ':' + pad(date.getMinutes()) +
    ':' + pad(date.getSeconds()) +
    diff + pad(tzOffset / 60) +
    ':' + pad(tzOffset % 60);
};

const getLocalDate = (date: string) => toISOStringWithTimezone(new Date(date));

const currentPage = ref(1);
const elementsPerPage = 10;

const get_rows = () => {
  var start = (currentPage.value - 1) * elementsPerPage;
  var end = start + elementsPerPage;
  return fileRowsData.value.slice(start, end);
}
const num_pages = () => {
  return Math.ceil(fileRowsData.value.length / elementsPerPage);
}

const handleChevronClick = (item) => {
  item.visible = !item.visible;
  tooltipKey.value += 1;
};


return (_ctx: any,_cache: any) => {
  const _component_sdds_tooltip = _resolveComponent("sdds-tooltip")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(get_rows(), (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("tr", {
            class: _normalizeClass(["sdds-table__row", { 'sdds-row-selected': item.showDetails }]),
            "data-test-id": "dataRowItem"
          }, [
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("button", {
                class: "sdds-btn sdds-btn-sm sdds-btn-ghost",
                onClick: ($event: any) => (handleChevronClick(item)),
                "data-test-id": "btviewDetails"
              }, [
                _createElementVNode("span", null, [
                  (!item.visible)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(che_down)
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (item.visible)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _unref(che_up)
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_5)
            ]),
            _createElementVNode("td", {
              class: "sdds-table__body-cell sdds-u-pl2 sdds-u-pr2 sdds-details-row",
              onClick: ($event: any) => (showDetailsRow(item))
            }, _toDisplayString(getLocalDate(item.createdOn)), 9, _hoisted_8),
            _createElementVNode("td", {
              class: "sdds-table__body-cell sdds-u-pl2 sdds-u-pr2 sdds-details-row",
              onClick: ($event: any) => (showDetailsRow(item)),
              "data-test-id": "dataFileName"
            }, _toDisplayString(item.fileName), 9, _hoisted_9),
            _createElementVNode("td", {
              class: "sdds-table__body-cell sdds-u-pl2 sdds-u-pr2 sdds-details-row",
              onClick: ($event: any) => (showDetailsRow(item))
            }, [
              _createTextVNode(_toDisplayString(item.fileStatus) + " ", 1),
              (item.fileDataError)
                ? (_openBlock(), _createBlock(_component_sdds_tooltip, {
                    key: tooltipKey.value,
                    placement: "top",
                    selector: '#top-' + index,
                    text: "There are some rows with errors"
                  }, null, 8, ["selector"]))
                : _createCommentVNode("", true),
              (item.fileDataError)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    id: 'top-' + index
                  }, _hoisted_13, 8, _hoisted_11))
                : _createCommentVNode("", true)
            ], 8, _hoisted_10)
          ], 2),
          (item.visible)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("ul", null, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(details, (subKey) => {
                      return _createElementVNode("li", { key: subKey }, [
                        _createElementVNode("strong", null, _toDisplayString(subKey) + ": ", 1),
                        _createElementVNode("span", null, _toDisplayString(item[subKey]), 1)
                      ])
                    }), 64))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    (num_pages() > 1)
      ? (_openBlock(), _createElementBlock("tfoot", _hoisted_16, [
          _createElementVNode("tr", _hoisted_17, [
            _createElementVNode("td", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    class: "sdds-table__page-selector-input sdds-input-numberpage",
                    type: "number",
                    min: "1",
                    id: "num-page",
                    max: num_pages(),
                    pattern: "[0-9]+",
                    dir: "rtl",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event))
                  }, null, 8, _hoisted_22), [
                    [_vModelText, currentPage.value]
                  ]),
                  _createElementVNode("p", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("span", null, _toDisplayString(num_pages()), 1),
                    _hoisted_25
                  ]),
                  _createElementVNode("button", {
                    class: "sdds-table__footer-btn",
                    disabled: currentPage.value <= 1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (currentPage.value--))
                  }, _hoisted_28, 8, _hoisted_26),
                  _createElementVNode("button", {
                    "data-test-id": "btNextPage",
                    class: "sdds-table__footer-btn",
                    disabled: currentPage.value >= num_pages(),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (currentPage.value++))
                  }, _hoisted_31, 8, _hoisted_29)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})